import React, { useEffect, useState } from "react";
import { subDays } from "date-fns";

import SaleService from "../../core/services/SaleService";
import {
   Chart as ChartJS,
   CategoryScale,
   LinearScale,
   PointElement,
   LineElement,
   BarElement,
   Title,
   Tooltip,
   Legend,
} from 'chart.js';
import { useQuery } from "@tanstack/react-query";
import 'react-circular-progressbar/dist/styles.css';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

ChartJS.register(
   CategoryScale,
   LinearScale,
   PointElement,
   LineElement,
   BarElement,
   Title,
   Tooltip,
   Legend
);

const SalesDashboard = () => {
   const [dateRange, setDateRange] = useState({
      start: subDays(new Date(), 30),
      end: new Date()
   });

   const [mappedByCompany, setMappedByCompany] = useState()

   const [totalSystemAssets, setTotalSystemAssets] = useState(0)
   const [totalSystemValue, setTotalSystemValue] = useState(0)

   const { data: assets, isLoading } = useQuery({
      queryKey: ["dashboard-asset"],
      queryFn: SaleService.getAllAsset,
   });




   useEffect(() => {
      if (assets) {
         const mappedByCompanys = assets?.records?.reduce((acc, record) => {

            if (!acc[record.company_id.display_name]) {
               acc[record.company_id.display_name] = [];
            }
            acc[record.company_id.display_name].push(record);
            return acc;
         }, {});

         const processedData = Object.entries(mappedByCompanys).map(([company, assets]) => {
            const totalAssets = assets.length;
            const totalValue = assets.reduce((sum, asset) => sum + asset.original_value, 0);
            const remainingValue = assets.reduce((sum, asset) => sum + asset.book_value, 0);
            const logo = assets[0]?.company_id?.logo
            return {
               company,
               totalAssets,
               totalValue,
               remainingValue,
               assets,
               logo
            };
         });



         let totalSystemAssets = processedData.reduce((acc, branch) => acc + branch.totalAssets, 0);



         let totalSystemValue = processedData.reduce((acc, branch) => acc + branch.totalValue, 0);


         setTotalSystemAssets(totalSystemAssets)
         setTotalSystemValue(totalSystemValue)
         setMappedByCompany(processedData)
      }
   }, [assets]);


   return (
      <div className="min-h-screen bg-gray-50 p-4 lg:p-8">
         <div className="flex flex-col justify-center items-center gap-6 mt-32">
            <div className="self-stretch h-full flex-col justify-start items-start gap-6 flex ">
               <div className="self-stretch h-full p-6 bg-white rounded-2xl border border-[#d3d5d8] flex-col justify-start items-start gap-6 flex">
                  <div className="text-[#1a1a1b] text-2xl font-medium font-['Inter'] leading-loose">Tổng quan về hệ thống</div>
                  <div className="self-stretch justify-start items-start gap-6 inline-flex">
                     <div className="grow shrink basis-0 p-4 bg-white rounded-xl border border-[#d3d5d8] flex-col justify-start items-start gap-3 inline-flex">
                        <div className="text-center text-[#636466] text-sm font-normal font-['Inter'] leading-tight">Tổng số lượng tài sản</div>
                        <div className="text-center text-[#1a1a1b] text-[32px] font-['Inter'] font-semibold leading-10">{totalSystemAssets.toLocaleString()}</div>
                     </div>
                     <div className="grow shrink basis-0 p-4 bg-white rounded-xl border border-[#d3d5d8] flex-col justify-start items-start gap-3 inline-flex">
                        <div className="text-center text-[#636466] text-sm font-normal font-['Inter'] leading-tight">Tổng giá trị tài sản</div>
                        <div className="justify-start items-baseline gap-1 inline-flex">
                           <div className="text-center text-[#1a1a1b] text-[32px] font-['Inter'] font-semibold leading-10">{totalSystemValue.toLocaleString()}</div>
                           <div className="text-center text-[#636466] text-lg font-medium font-['Inter'] leading-normal">VND</div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
            <div className="self-stretch justify-start items-start gap-6 inline-flex">
               {!isLoading && mappedByCompany?.map((item, index) => (
                  <div className="grow shrink basis-0 p-6 bg-white rounded-2xl border border-[#d3d5d8] flex-col justify-start items-start gap-6 inline-flex">
                     <div className="justify-center items-center gap-2.5 inline-flex">
                        {/* <img className="w-11 h-11 rounded-lg" src={item.logo} style={{
                           objectFit: 'fit' // or 'contain' based on your needs
                        }} /> */}
                        <div className="text-[#1a1a1b] text-lg font-semibold font-['Inter'] leading-normal">{item.company}</div>
                     </div>
                     <div className="self-stretch  flex-col justify-start items-start gap-6 flex">
                        <div className="self-stretch  p-4 bg-white rounded-xl border border-[#d3d5d8] flex-col justify-center items-start gap-3 flex">
                           <div className="text-center text-[#636466] text-sm font-normal font-['Inter'] leading-tight">Số lượng tài sản</div>
                           <div className="justify-start items-baseline gap-2 inline-flex">
                              <div className="text-center text-[#1a1a1b] text-2xl font-semibold font-['Inter'] leading-loose">{item.totalAssets.toLocaleString()}</div>
                              {/* <div className="text-center"><span class="text-[#1fc16b] text-sm font-medium font-['Inter'] leading-tight">+5</span><span class="text-[#1fc16b] text-sm font-normal font-['Inter'] leading-tight"> </span><span class="text-[#636466] text-sm font-normal font-['Inter'] leading-tight">từ tháng trước</span></div> */}
                           </div>
                        </div>
                        <div className="self-stretch p-4 bg-white rounded-xl border border-[#d3d5d8] justify-between items-start inline-flex gap-2">
                           <div className="grow shrink basis-0 flex-col justify-start items-start gap-6 inline-flex">
                              <div className="h-[52px] flex-col justify-start items-start gap-2 flex">
                                 <div className="justify-start items-center gap-2 inline-flex">
                                    <div className="p-0.5 bg-white rounded-[99px] shadow-[0px_1px_4px_0px_rgba(34,34,34,0.16)] justify-start items-center gap-1 flex">
                                       <div className="w-2 h-2 bg-[#ffebec] rounded-lg" />
                                    </div>
                                    <div className="text-center text-[#636466] text-sm font-normal font-['Inter'] leading-tight">Giá trị tài sản</div>
                                 </div>
                                 <div className="justify-start items-baseline gap-1 inline-flex">
                                    <div className="text-center text-[#1a1a1b] text-base font-semibold font-['Inter'] leading-normal">{item.totalValue.toLocaleString()}</div>
                                    <div className="text-center text-[#a8aaae] text-xs font-semibold font-['Inter'] leading-none">VND</div>
                                 </div>
                              </div>
                              <div className="h-[52px] flex-col justify-start items-start gap-2 flex">
                                 <div className="justify-start items-center gap-2 inline-flex">
                                    <div className="p-0.5 bg-white rounded-[99px] shadow-[0px_1px_4px_0px_rgba(34,34,34,0.16)] justify-start items-center gap-1 flex overflow-hidden">
                                       <div className="w-2 h-2 bg-[#fb3748] rounded-lg" />

                                    </div>
                                    <div className="text-center text-[#636466] text-sm font-normal font-['Inter'] leading-tight">Giá trị tài sản sau khấu hao</div>
                                 </div>
                                 <div className="justify-start items-baseline gap-1 inline-flex">
                                    <div className="text-center text-[#1a1a1b] text-base font-semibold font-['Inter'] leading-normal">{item.remainingValue.toLocaleString()}</div>
                                    <div className="text-center text-[#a8aaae] text-xs font-semibold font-['Inter'] leading-none">VND</div>
                                 </div>
                              </div>
                           </div>
                           <div className="w-[180px] h-[180px] relative">
                              <CircularProgressbar value={(item.remainingValue * 100) / item.totalValue} strokeWidth={30} styles={buildStyles({
                                 // Rotation of path and trail, in number of turns (0-1)
                                 strokeLinecap: "butt",
                                 pathColor: `#fb3748`,
                                 trailColor: '#FFC0C5',
                              })} />

                           </div>
                        </div>
                     </div>
                  </div>
               ))}



            </div>
         </div>
      </div>
   );
};

export default SalesDashboard;
